'use client';
import { useEffect } from 'react';
import { useGoogleAnalytics, initGA } from '@/lib/analytics';

export default function GoogleAnalytics() {
  useEffect(() => {
    initGA();
  }, []);

  useGoogleAnalytics();

  return null;
}